import axios from "axios";
import { tmsApi } from "../api";




export const toggleCompanyMMT = (obj,body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*"
    },
  };
  try {
    return axios
    .post(tmsApi + `v1/entities/corporateclient/ridetype/${obj.companyId}`,body, config)
    .then((resp) => {
      console.log(resp, "response");
      return resp;
    });

  } catch (error) {
    console.log("error", error);
  }
};
